// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__CMV6C","head":"ProcedureTableInfo_head__1MPbc"};